/**
 * Recursively converts object keys to camel case
 */
export const camelCaseObjectKeys = (object) => {
  if (typeof object !== 'object' || !object) {
    return object;
  }

  // eslint-disable-next-line no-use-before-define
  const camelCaseObject = camelCaseArray(object) || {};

  if (object && !camelCaseObject.length) {
    Object.keys(object).forEach((key) => {
      const camelCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
      camelCaseObject[camelCaseKey] = camelCaseObjectKeys(object[key]);
    });
  }

  return camelCaseObject;
};

/**
 * Recursively converts object keys to camel case
 * This function just change the properties of your object, not the value or the types of your properties.
 */
export const camelCaseArray = (object) => {
  if (Array.isArray(object)) {
    object.forEach((element, index) => {
      object[index] = camelCaseObjectKeys(element);
    });
    return object;
  }

  return null;
};
